export default {
	isLoggedIn: (state) => state.isLoggedIn,
	toast: (state) => state.toast,
	pageLoading: (state) => state.pageLoading,
	currentDashboard: (state) => state.currentDashboard,
	storeNamespace: (state) => state.storeNamespace
}
